import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'CashFlowCategories',
  initialState,
  reducers: {
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getCashFlowCategoriesSuccess(state, action) {
      state.data = action.payload.data;
    },

    addOrUpdateCashFlowCategories(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getCashFlowCategories(locationId, isTransfer = false) {
  return async () => {
    try {
      const response = await get(`CashFlowCategories?locationId=${locationId}&isTransfer=${isTransfer}`);
      if (response.status) {
        dispatch(slice.actions.getCashFlowCategoriesSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addCashFlowCategories(body) {
  return async () => {
    try {
      const response = await post(`CashFlowCategories`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlowCategories(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateCashFlowCategories(body) {
  return async () => {
    try {
      const response = await put(`CashFlowCategories`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateCashFlowCategories(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
